import { lazy, useMemo } from 'react';
import { getConfig } from '@gokrew/ui/runtime-config';
import { useTour } from '@gokrew/ui/hooks';
import { buildDashboardTourVariant } from '@/hooks/tours/tourVariants';
import { OnLeaveTodayCard } from './OnLeaveTodayCard';
import { AnnouncementsCard } from './AnnouncementsCard';
import { PublicHolidaysCard } from './PublicHolidaysCard/PublicHolidaysCard';

const TourGuide = lazy(() =>
  import('@gokrew/ui/components/TourGuide/TourGuide').then((m) => ({
    default: m.TourGuide,
  }))
);
const MyLeaveCard = lazy(() =>
  import('./MyLeaveCard/MyLeaveCard').then((m) => ({
    default: m.MyLeaveCard,
  }))
);
import styles from './DashboardPage.module.css';
import { NeedsAttention } from './NeedsAttention';
import { TeamSnapshot } from './TeamSnapshot';

export default function Dashboard() {
  const { ENABLE_ANNOUNCEMENT } = getConfig();
  const dashboardTourVariant = useMemo(
    () => buildDashboardTourVariant(!!ENABLE_ANNOUNCEMENT),
    [ENABLE_ANNOUNCEMENT]
  );
  const { steps, run, onFinish } = useTour(dashboardTourVariant);
  return (
    <div className={styles.page}>
      <TourGuide steps={steps} run={run} onFinish={onFinish} />

      <div className={styles.grid}>
        <div className={styles.mainColumn}>
          <NeedsAttention />
          <TeamSnapshot />
          {ENABLE_ANNOUNCEMENT && (
            <AnnouncementsCard dataTour="emp-dashboard-announcements" />
          )}
        </div>
        <div className={styles.sideColumn}>
          <MyLeaveCard dataTour="emp-dashboard-my-leave" />
          <OnLeaveTodayCard dataTour="emp-dashboard-on-leave" />
          <PublicHolidaysCard dataTour="emp-dashboard-holidays" />
        </div>
      </div>
    </div>
  );
}
